import { Box, Typography, TableContainer, Table, TableHead, TableRow, TableCell, Paper, TableBody, IconButton, SpeedDial, SpeedDialAction, Button } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import AddIcon from '@mui/icons-material/Add'
import { useNavigate } from 'react-router'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useUtiles } from '../../../../shared/context/utilesContext'
import AddSubTaskFormComponent from '../AddSubTaskFormComponent'
import { useTaskContext } from '../../../../shared/context/taskContext'
import { useState, useEffect } from 'react'

export default function SubTaskFormComponent() {
    const theme = useTheme()
    const navigate = useNavigate()
    const isMobile = useMediaQuery('(max-width: 600px)')
    const { toogleOpenSilder, generateRandomCode } = useUtiles()



    const { subtaskList, setSubtask, setSubtaskList, indexSubtask, setIndexSubtask, resetSubtask, stepActive, handleStep, handleStepBack } = useTaskContext()


    const handleEditSubtask = (index) => {
        setSubtask(subtaskList[index])
        setIndexSubtask(index)
        toogleOpenSilder(<AddSubTaskFormComponent />, 500, 'Editar sub tarea')
    }

    const handleDeleteSubtask = (index) => {
        const newSubtaskList = subtaskList.filter((_, i) => i !== index)
        //reordenar las subtareas
        newSubtaskList.forEach((subtask, i) => {
            subtask.order = i + 1
        })
        setSubtaskList(newSubtaskList)
    }

    const handleAddSubtask = () => {
        resetSubtask()
        toogleOpenSilder(<AddSubTaskFormComponent />, 500, 'Agregar sub tarea')
    }

    useEffect(() => {
        //solo al iniciar el componente cambiar el codigo de la primera subtarea
        if (subtaskList.length > 0 && !subtaskList[0].code) {
            subtaskList[0].code = generateRandomCode()
        }
    }, [])
 

    return (
        <Box sx={{ mb: "60px" }}>
            <Typography variant="h4" sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px', marginBottom: '10px' }}>SubTareas registradas</Typography>

            <TableContainer>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ backgroundColor: theme.palette.background.medium }}></TableCell>
                            <TableCell sx={{ backgroundColor: theme.palette.background.medium }}>Orden</TableCell>
                            <TableCell sx={{ backgroundColor: theme.palette.background.medium }}>Descripción</TableCell>
                            <TableCell sx={{ backgroundColor: theme.palette.background.medium }}>Tipo</TableCell>
                            <TableCell sx={{ backgroundColor: theme.palette.background.medium }}>Obligatorio</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {subtaskList.map((subtask, index) => (
                            <TableRow key={index}>
                                <TableCell sx={{ backgroundColor: theme.palette.background.paper, width: '100px' }}>
                                    <Box sx={{ display: 'flex', gap: '10px' }}>
                                        <IconButton onClick={() => handleEditSubtask(index)}>
                                            <EditNoteOutlinedIcon />
                                        </IconButton>
                                        <IconButton onClick={() => handleDeleteSubtask(index)}>
                                            <DeleteOutlineOutlinedIcon />
                                        </IconButton>
                                    </Box>
                                </TableCell>
                                <TableCell sx={{ backgroundColor: theme.palette.background.paper, width: '50px' }}>{subtask.order}</TableCell>
                                <TableCell sx={{ backgroundColor: theme.palette.background.paper, width: '200px' }}>{subtask.description}</TableCell>
                                <TableCell sx={{ backgroundColor: theme.palette.background.paper, width: '100px' }}>{subtask.type_field}</TableCell>
                                <TableCell sx={{ backgroundColor: theme.palette.background.paper, width: '40px' }}>{subtask.is_mandatory ? 'SI' : 'NO'}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <SpeedDial
                ariaLabel="Add"
                sx={{ position: 'absolute', bottom: isMobile ? 40 : 80, right: 8 }}
                icon={<AddIcon />}
                direction="right"
                openIcon={<AddIcon />}
                onClick={handleAddSubtask}
            />


            <Box sx={{ display: 'flex', justifyContent: 'start', gap: '10px', alignItems: 'center', marginTop: '20px', position: 'absolute', bottom: '20px', left: '20px', right: '20px' }}>
                <Button
                    variant="contained"
                    onClick={handleStepBack}
                    disabled={stepActive === 1}
                    sx={{
                        borderRadius: '8px',
                        padding: '8px 25px',
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        borderRadius: '50px',
                        transition: 'all 0.2s',
                        "&:hover": {
                            backgroundColor: theme.palette.primary.dark,
                            transform: 'translateY(-2px)'
                        }
                    }}
                >
                    Anterior
                </Button>

                <Button
                    variant="contained"
                    onClick={handleStep}
                    disabled={subtaskList.length === 0}
                    sx={{
                        borderRadius: '8px',
                        padding: '8px 25px',
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        borderRadius: '50px',
                        transition: 'all 0.2s',
                        "&:hover": {
                            backgroundColor: theme.palette.primary.dark,
                            transform: 'translateY(-2px)'
                        }
                    }}
                >
                    Siguiente
                </Button>
            </Box>

        </Box>
    )
}